import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import companyGroupQueryKeys from './companyGroupQueryKeys'
import { updateSubsidiaryAcquisitions } from '../service/subsidiaryService'
import { Company } from '../../../types/company/Company'
import { CompanyGroup } from './getCompanyGroupOptions'

export const useUpdateSubsidiaryAcquisitions = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (subsidiary: Company) => {
      if (!companyId) throw new Error('Company ID is required')
      return updateSubsidiaryAcquisitions(companyId, subsidiary)
    },
    onSuccess: updated => {
      queryClient.setQueryData<CompanyGroup>(companyGroupQueryKeys.group({ companyId }), old =>
        old ? { ...old, subsidiaries: old.subsidiaries.map(s => (s.id === updated.id ? updated : s)) } : old
      )
    }
  })
}
